<template>
  <v-menu 
    v-if="!isUpdating"
    bottom
    offset-y
    class="logo-link"
    >

    <img v-if="hasPostContext && logo.image_url && $vuetify.breakpoint.mdAndUp"
      :src="logo.image_url"
      slot="activator"
      :style="logoStyle"
    >
    <span v-else
      slot="activator"
      :style="logoStyle"
    >
      {{ logoText }}
    </span>
    <v-list style="width: 244px;">
      <v-list-tile v-for="item in companies" :key="item.id" :to="routeCompanyHome(item)">
        <v-list-tile-title>{{ item.name }}</v-list-tile-title>
      </v-list-tile>
      <v-list-tile :to="{name: 'account'}" exact>
        <v-list-tile-title>Личный кабинет</v-list-tile-title>
      </v-list-tile>
      <v-list-tile @click="logout">
        <v-list-tile-title>
          Выход <v-icon>mdi-logout-variant</v-icon>
        </v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
  <span v-else :style="logoStyle" v-html="defaultLogo.text"></span>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'AppLogo',

  computed: {
    ...mapState(`app/layout`, [
      'routeStatus',
      'routeError',
      'isDarkTheme',
      'hasPostContext',
      'isUpdating'
    ]),
    ...mapState(`app/account`, ['postId', 'companies', 'logo', 'defaultLogo']),
    ...mapGetters('app/layout', ['getRouteData']),
    ...mapGetters('app/account', {
      logoStyle: 'getLogoStyle'
    }),
    logoText: function() {
      let text = this.hasPostContext
        ? this.logo.text 
        : 'Личный Кабинет'
      return text
    }
  },

  methods: {
    routeCompanyHome: function(company) {
      
      let query = {}
      company.posts.map(post => {
        if(post.default) query.pid = post.id
      })
      
      return { name: 'org.hierarchy', params: { cid: company.id }, query }
      //return this.getRouteData({ name: 'org.hierarchy', params: { cid: company.id }, query })
    },
    
    logout() {
      this.$store.dispatch("app/account/signOut").then(() => {
        document.location.assign('/')
      })
    }
  }
}
</script>

<style>
  .logo-link{
    /* margin: 0 !important; */
    height: 48px;
    overflow: hidden;
  }
</style>


// WEBPACK FOOTER //
// src/components/Header/src/components/AppLogo.vue